module.exports = __webpack_public_path__ + "static/img/Fin.b7959f72.jpg";